//import "@hotwired/turbo-rails"
import Rails from '@rails/ujs';
Rails.start();

import { start as startTurboLinks } from "turbolinks";
startTurboLinks();

import LocalTime from "./localtime.cjs";
LocalTime.start();
window.LocalTime = LocalTime;

import 'jquery-address';

